import { Box, Typography, Tooltip, useTheme } from "@mui/material";
import { CheckStatusChip } from "../../../../../components/CheckStatusChip/CheckStatusChip";

export const LinkedChecksInfo = ({ control, toShowStatus = false }) => {
  const theme = useTheme();
  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
        <Box
          sx={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            backgroundColor: theme.palette._blue.main,
            mr: 1.5,
          }}
        />
        <span style={{ fontWeight: 600, color: theme.palette._blue.main }}>
          Checks Linked ({control?.associated_checks?.length})
        </span>
      </Box>
      <Box>
        {control?.associated_checks?.map((check, checkIdx) => (
          <Box
            key={check?.active_check_id || check?.id || checkIdx}
            sx={{
              p: 1.5,
              borderRadius: 1,
              borderLeft: `3px solid ${theme.palette._blue.main}`,
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              background: theme.customColors.background.main,
              mb: 0.5,
              mt: 0,
              transition: "all 0.2s ease",
              "&:hover": {
                boxShadow: theme.customColors.shadow.main,
                transform: "translateY(-1px)",
              },
            }}
          >
            <Box
              sx={{
                width: 24,
                height: 24,
                bgcolor: theme.palette._blue.light,
                color: theme.palette._blue.main,
                fontSize: "0.7rem",
                fontWeight: 700,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
              }}
            >
              #{checkIdx + 1}
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography
                variant="body2"
                fontWeight={500}
                color={theme.customColors.text.strong}
                sx={{ lineHeight: 1.3 }}
              >
                {check?.active_check_description}
              </Typography>
              <Typography
                variant="caption"
                color={theme.customColors.text.secondary}
              >
                ID: {check?.active_check_id}
              </Typography>
            </Box>
            {toShowStatus && (
              <>
                <Tooltip title={check?.check_status_reason} arrow>
                  <span>
                    <CheckStatusChip status={check?.check_status} />
                  </span>
                </Tooltip>
              </>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};
